const commonDefaultState = {
  currentTokenValue: null,
  // generate random number for tracking percent
  numberTrackingPercent: Math.random(),
}

export default commonDefaultState
